$(document).ready(function(){
	// Inity vyvolavane v main.js
});

SiteFunctions = {
	init: function() {
		$(".open-search").click(function() {
			if ($(window).width() < 981) {
				Menu.MainMenu.hide();
				$(".openned").removeClass('openned');
			}

			$(".search-field").fadeIn("fast");
			$("#search-input").focus();
	
			setTimeout(function() {
				$(".placeholder").fadeOut("slow");
			}, 300);
	
			$(".search-field").addClass("opened");
			$(".open-search").fadeOut("fast", function() {
				$(".close-search").fadeIn();
			});
		});
	
		$(".close-search").click(function() {
			// if ($(window).width() < 981) {
			// 	Menu.MainMenu.show();
			// }

			$(".search-field").removeClass("opened");
			$(".search-field").fadeOut("fast");
			$(".close-search").fadeOut("fast", function() {
				$(".open-search").fadeIn();
			});
		});
	
		$("form.search").click(function() {
			$(".placeholder").fadeOut("slow");
			$("#search-input").focus();
		});

		var opened = false;
		$(".lang-selection").click(function() {
			if (!opened) {
				$(".langs").css("overflow", "visible");
				$(".lang-selection").css("opacity", .7);
				$(".langs-popup").css("height", "200px");
			} else {
				$(".langs-popup").css("height", "0px");
				$(".lang-selection").css("opacity", 1);
				setTimeout(function() { $(".langs").css("overflow", "hidden"); }, 500);
			}

			opened = !opened;
		}); 
	},
}

ScrollableElement = {

	init: function() {

		var observ = $(".page-content");
		MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

		var observer = new MutationObserver(function(mutations, observer) {
			// fired when a mutation occurs
			var scrollEl = $(".right-col");
			var scrollHeightCheck = $("content");
	
			var contentHeight = scrollHeightCheck.height();
			var scrollElHeight = scrollEl.height();
	
			observ.on('scroll', function(event) {
				if (observ.scrollTop() > 120) {
					scrollEl.addClass("fixed");
	
					if ((observ.scrollTop() + scrollElHeight - 100) > (contentHeight - 240)) {
						scrollEl.addClass("bottom");
					} else {
						scrollEl.removeClass("bottom");
					}
				} else {
					scrollEl.removeClass("fixed");
					scrollEl.removeClass("bottom");
				}
			});
		});

		observer.observe(observ[0], {
			subtree: true,
			attributes: true
		});

	}
}

Homepage = {
	
	initVideo: function (PAGE) {

		PAGE = PAGE ? PAGE : $('body');
		this.homepage = PAGE.find('section');

		if(!this.homepage.length) return;

		var video = $('<video first-view id="video" poster="/files/stars-poster.jpg" playsinline muted loop></video>');
		var source = "";

		// if (window.matchMedia("(min-width: 1300px)").matches){
			source = $('<source src="' +WEB_ROOT+ '/files/stars-min3.mp4" type="video/mp4">');
		// } else if (window.matchMedia("(min-width: 980px)").matches){
			// source = $('<source src="' +WEB_ROOT+ '/files/video-med.mp4" type="video/mp4">');
		// } else {
			// source = $('<source src="' +WEB_ROOT+ '/files/video-small.mp4" type="video/mp4">');
		// }

		source.appendTo(video);
		video.insertAfter(this.homepage);
		video[0].play();
	},

	initAnims: function () {
		if ($(".homepage").length == 0) {
			$("body").addClass("not-homepage");
		}

		$("[first-view]").removeAttr("first-view");

		setTimeout(function() {
			$(".row.header, section, body").addClass("after-first-visit");
		}, 2500);
	},
}
